import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import Badge from '@material-ui/core/Badge';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import { blueGrey} from '@material-ui/core/colors';

function ElevationScroll(props) {
  const { children, window } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
    target: window ? window() : undefined,
  });

  return React.cloneElement(children, {
    elevation: trigger ? 4 : 0,
  });
}
ElevationScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};


const useStyles = makeStyles((theme) => ({

  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    textAlign: "left",
    textTransform:'uppercase'
  },

  butget: {
    marginRight:  theme.spacing(3),
    marginLeft:  theme.spacing(1),
  },

  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
      textAlign: "center",
    },
  },

  appbar:{
    background:'red' 
  },

}));





export default function TopAppBar(props) {
  const classes = useStyles();

   const {title,size,position, basket,strings, onClickNavigation, onClickCheckout} = props; 
   const colorBlueGrey = blueGrey[800]; 
   const colorPrimary = 'primary'

  return (
    
    <div>
      {/* <HideOnScroll {...props}> */}
      <AppBar color={colorPrimary}>
        <Toolbar>

          <Typography variant="subtitle1" className={classes.title}>
          {title}
          </Typography>

          { basket>0 &&
            <IconButton  aria-label="Checkout" color="accent" onClick ={onClickCheckout} px={3} >
                <Badge badgeContent={basket} color="accent">
                  <ShoppingBasketIcon />
                </Badge>
                <Typography px={2} variant="button" className = {classes.sectionDesktop}>
                  {strings.action_order}
                </Typography>
            </IconButton>
          }

          {onClickNavigation &&
          <IconButton
            edge="end"
            onClick ={onClickNavigation}
            className={classes.menuButton} 
            aria-label="menu">

           {size && size>1
           ? 
           <Badge badgeContent={size} color="accent">
            <MenuIcon/>
           </Badge>  
           :
           <MenuIcon/>
           }

          </IconButton>
          }

        </Toolbar>
      </AppBar>
      <Toolbar/>
      {/* </HideOnScroll> */}
        
    </div>
   
  );
}
